import { render, staticRenderFns } from "./scrollDiv.vue?vue&type=template&id=2c0bff1e&"
import script from "./scrollDiv.vue?vue&type=script&lang=js&"
export * from "./scrollDiv.vue?vue&type=script&lang=js&"
import style0 from "./scrollDiv.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports